module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainNav"
  }, [(_vm.store.getters.tabModeGet == 0) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/home"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '0')
      }
    }
  }, [_c('b', [_vm._v("Home")])]) : _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/home"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '0')
      }
    }
  }, [_vm._v("Home")]), _vm._v(" "), (_vm.store.getters.tabModeGet == 6) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/resume"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '6')
      }
    }
  }, [_c('b', [_vm._v("Personal Resumé")])]) : _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/resume"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '6')
      }
    }
  }, [_vm._v("Personal Resumé")]), _vm._v(" "), (_vm.store.getters.tabModeGet == 7) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/vision"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '7')
      }
    }
  }, [_c('b', [_vm._v("Vision:"), _c('br'), _vm._v("Web & Robotics")])]) : _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/vision"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '7')
      }
    }
  }, [_vm._v("Vision:"), _c('br'), _vm._v("Web & Robotics")]), _vm._v(" "), (_vm.store.getters.tabModeGet == 1) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-react"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '1')
      }
    }
  }, [_c('b', [_vm._v("Web FrontEnd:"), _c('br'), _vm._v("JavaScript React")])]) : _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-react"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '1')
      }
    }
  }, [_vm._v("Web FrontEnd:"), _c('br'), _vm._v("JavaScript React")]), _vm._v(" "), (_vm.store.getters.tabModeGet == 2) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-vue-js"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '2')
      }
    }
  }, [_c('b', [_vm._v("Web FrontEnd:"), _c('br'), _vm._v("JavaScript Vue.js")])]) : _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-vue-js"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '2')
      }
    }
  }, [_vm._v("Web FrontEnd:"), _c('br'), _vm._v("JavaScript Vue.js")]), _vm._v(" "), (_vm.store.getters.tabModeGet == 3) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-node-js"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '3')
      }
    }
  }, [_c('b', [_vm._v("Web BackEnd:"), _c('br'), _vm._v("JavaScript Node.js")])]) : _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-node-js"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '3')
      }
    }
  }, [_vm._v("Web BackEnd:"), _c('br'), _vm._v("JavaScript Node.js")]), _vm._v(" "), (_vm.store.getters.tabModeGet == 4) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-robotics"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '4')
      }
    }
  }, [_c('b', [_vm._v("JavaScript/"), _c('br'), _vm._v("Python:"), _c('br'), _vm._v("Robotics")])]) : _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-robotics"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '4')
      }
    }
  }, [_vm._v("JavaScript/"), _c('br'), _vm._v("Python:"), _c('br'), _vm._v("Robotics")]), _vm._v(" "), (_vm.store.getters.tabModeGet == 5) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-industry-siemens"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '5')
      }
    }
  }, [_c('b', [_vm._v("JavaScript/"), _c('br'), _vm._v("Python:"), _c('br'), _vm._v("Industry")])]) : _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-industry-siemens"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '5')
      }
    }
  }, [_vm._v("JavaScript/"), _c('br'), _vm._v("Python:"), _c('br'), _vm._v("Industry")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-600eb98a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainNav.vue
// module id = 122
// module chunks = 1